import * as React from "react";
import { forwardRef } from "react";
const ShoulderStrapsSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M5 3h14v6l-7 5-7-5zm7 1 1.103 2.482 2.701.282-2.02 1.816.567 2.656L12 9.876l-2.351 1.36.567-2.656-2.02-1.816 2.701-.282z", clipRule: "evenodd" }),
    React.createElement("path", { d: "m5 11 7 5 7-5v2l-7 5-7-5z" }),
    React.createElement("path", { d: "m5 15 7 5 7-5v2l-7 5-7-5z" }));
const ForwardRef = forwardRef(ShoulderStrapsSVG);
export default ForwardRef;
//# sourceMappingURL=ShoulderStraps.js.map